import { stringify } from 'query-string';

import { BASE_URL_V2 } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'PRACTICE_SHEETS_GET',
  GET_SUCCESS: 'PRACTICE_SHEETS_SUCCESS',
  GET_FAILURE: 'PRACTICE_SHEETS_FAILURE',
};

export const get = actions.get(
  (studentId, query) =>
    `${BASE_URL_V2}/students/${studentId}/practice-sheets/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
